import type { StatsRole } from '../types'

/**
 * Role names per sport, used in the season table title
 * ("Skater Statistics", "Keeper Statistics", …). Moved from
 * the old web player page utils so mobile can share them.
 */
export const getPlayerTitle = (
  sportName: string | null,
  isGenericSport: boolean
): string => {
  if (isGenericSport || sportName === 'soccer') {
    return 'Player'
  }
  if (sportName === 'hockey') {
    return 'Skater'
  }
  return 'Player'
}

export const getGoalieTitle = (sportName: string | null): string =>
  sportName === 'soccer' ? 'Keeper' : 'Goalie'

/**
 * Title for the selected role. `/progress/sports` carries no `is_generic`
 * flag, so generic sports fall through `getPlayerTitle`'s default ('Player').
 */
export const getRoleTitle = (
  role: StatsRole,
  sportName: string | null
): string =>
  role === 'goalie'
    ? getGoalieTitle(sportName)
    : getPlayerTitle(sportName, false)
